import { render, staticRenderFns } from "./InvestorQuestionAnswer.vue?vue&type=template&id=a31c8de2&"
import script from "./InvestorQuestionAnswer.vue?vue&type=script&lang=js&"
export * from "./InvestorQuestionAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports